import * as React from 'react';
import { Row } from 'react-bootstrap';
import { reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { IAuthState } from '../../../../services/auth/models';
import ForgottenPasswordForm from './components/ForgottenPasswordForm';
import Helmet from 'react-helmet';
import {IChannel} from '../../../../data/api/models';

interface IForgottenPasswordProps {
  auth: IAuthState;
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
  };
  channel: IChannel;
}

class ForgottenPassword extends React.Component<IForgottenPasswordProps> {
  private handleSubmit = (values) => {
    const { actions, channel } = this.props;
    const request = {
      email: values.email,
      scheme: window.location.protocol.replace(':', ''),
      host: window.location.host,
      requestItems: {
        channel: channel.key,
      },
    };

    actions.auth.forgottenPassword(request);
  }

  public render() {
    const { auth } = this.props;

    return (
      <Row className="page-container">
        <Helmet>
          <title>Forgotten Password</title>
        </Helmet>
        <div className="customer-section-title">
          <h1>Forgotten Password</h1>
          {!auth.resetPassword && <h4>Please provide the information below, in order to reset your password</h4>}
        </div>
        {!auth.resetPassword ? (
          <ForgottenPasswordForm onSubmit={this.handleSubmit}/>
        ) : (
          <div className="blue-section">
            <p>Thank you for submitting this request, an email has been sent with a link to reset your password.</p>
            <p>Note: this email will expire in 24 hours</p>
          </div>
        )}
      </Row>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'forgotten_password',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('forgotten_password');

    return component;
  },
  connect(
    (state) => {
      return {
        auth: state.auth,
        channel: state.branding.channel,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
      },
    }),
  ),
])(ForgottenPassword);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/ForgottenPassword/index.tsx